import { z } from "zod";

// Configuración de Identidad del SaaS
export const systemSettingsSchema = z.object({
  systemName: z.string().min(1, "El nombre del sistema es obligatorio"),
  supportEmail: z.string().email("Email inválido"),
  supportPhone: z.string().min(6, "Teléfono demasiado corto"),
  publicUrl: z.string().url("URL inválida"),
});

// Branding por defecto (lo que ven si su plan no permite Custom)
export const systemBrandingSchema = z.object({
  logoUrl: z.string().url().optional().nullable(),
  faviconUrl: z.string().url().optional().nullable(),
  primaryColor: z.string().default("#0f172a"),
  secondaryColor: z.string().default("#38bdf8"),
  backgroundColor: z.string().default("#ffffff"),
});

export const systemBusinessSettingsSchema = z.object({
  businessConf: z.object({
    currency: z.string().min(1, "La moneda es obligatoria"),
    language: z.string().min(2),
    taxDefault: z.coerce.number().min(0).max(100),
    defaultBufferTime: z.coerce.number().min(0),
    allowedDurations: z.string().transform((val) => val.split(',').map(Number)),
  }),
});

export const systemCalendarSettingsSchema = z.object({
  calendarConf: z.object({
    slotInterval: z.coerce.number().positive(),
    defaultDuration: z.coerce.number().positive(),
    minNoticeHours: z.coerce.number().min(0),
    maxFutureDays: z.coerce.number().positive(),
  }),
});

// Flags Globales (Interruptores maestros)
export const systemFlagsSchema = z.object({
  registrationEnabled: z.boolean().default(true),
  paymentsEnabled: z.boolean().default(false),
  maintenanceMode: z.boolean().default(false),
  emailNotifications: z.boolean().default(true),
  whatsappNotifications: z.boolean().default(false),
  onlineBooking: z.boolean().default(true),
});

// Límites GLOBALES (El techo máximo absoluto del servidor)
export const systemLimitsSchema = z.object({
  maxPros: z.number().min(1, "Debe ser mayor que 0").max(50, "Debe ser menor o igual que 50"),
  maxServices: z.number().min(1, "Debe ser mayor que 0").max(100, "Debe ser menor o igual que 100"),
  maxClinics: z.number().min(1, "Debe ser mayor que 0").max(10, "Debe ser menor o igual que 10"),
  maxPatients: z.number().min(1, "Debe ser mayor que 0").max(5000, "Debe ser menor o igual que 5000"),
});
